import { useContext, useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { HttpStatusCode } from 'axios';

import { RootStoreContext } from 'index';
import Button from 'components/common/Button/Button';
import Spinner from 'components/common/Spinner/Spinner';
import { notify } from 'components/common/Toast/toast.helpers';
import { MainContactPosition } from 'components/intermediaryApplications/intermediaryApplications.enums';

import styles from './UsersDeleteForm.module.scss';
import { HandlingDeleteToastMessage } from './userDeleteForm.enums';
import { ToastMessage } from '../../../common/Toast/toast.enums';

interface UsersDeleteFormProps {
  userId: number;
  onClose: () => void;
}

const UsersDeleteForm = ({ userId, onClose }: UsersDeleteFormProps) => {
  const { usersStore } = useContext(RootStoreContext);
  const { user, isUserProfileLoading, deleteUser, getUserById } = usersStore;
  const [isDeletingLoading, setIsDeletingLoading] = useState<boolean>(false);
  const [isInitialDataLoading, setIsInitialDataLoading] = useState<boolean>(true);

  const loadInitialData = async () => {
    try {
      setIsInitialDataLoading(true);
      await getUserById(userId);
    } catch (error: any) {
      notify(error.message || ToastMessage.DefaultError, 'error');
    } finally {
      setIsInitialDataLoading(false);
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const handleDeleteUser = async () => {
    try {
      setIsDeletingLoading(true);
      await deleteUser(user!.id);
      notify(HandlingDeleteToastMessage.Success, 'success');
      onClose();
    } catch (error: any) {
      notify(error.message || ToastMessage.DefaultError, 'error');
    } finally {
      setIsDeletingLoading(false);
    }
  };

  if (isInitialDataLoading || isUserProfileLoading) {
    return (
      <div className={styles.spinner}>
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <p className={styles.text}>
        Are you sure you want to delete this user - {user!.firstName} {user!.lastName}?
      </p>
      <div className={styles.buttonsContainer}>
        <Button onClick={handleDeleteUser} className={styles.saveButton} isLoading={isDeletingLoading}>
          Yes, Delete User
        </Button>
        <Button onClick={onClose} className={styles.closeButton}>
          No, Go Back
        </Button>
      </div>
    </div>
  );
};

export default observer(UsersDeleteForm);
